unable to read source [project]/node_modules/src/ui/scanner/camera-zoom-ui.ts